import React from 'react';

import IconButton from '@components/IconButton';
import Icon from '@components/Icon';
import useLocalStorage from '@hooks/useLocalStorage';

interface AirdropBannerProps {}

const AirdropBanner = ({}: AirdropBannerProps) => {
  const [showBanner, setShowBanner] = useLocalStorage(
    'show-airdrop-banner',
    'false'
  );

  const handleCloseButtonClick = () => setShowBanner('false');

  return (
    <>
      {showBanner === 'true' && (
        <div className="bg-blue px-6 py-2 text-white text-body font-semibold relative text-center">
          🍀 Lucky Draw - Lorem ipsum dolor sit amet, consectetur adipiscing
          elit.&nbsp;
          <a href="" title="Learn more" className="underline">
            Learn more
          </a>
          &nbsp;🍀
          <IconButton
            className="text-iconMedium absolute right-0 top-0 -m-1 mr-2 mt-1"
            onClick={handleCloseButtonClick}
          >
            <Icon.Close />
          </IconButton>
        </div>
      )}
    </>
  );
};

export default AirdropBanner;
